<template>
  <div class="contions">
    <Title-b title="我的订单" />
    <!--SumFree SumWeight</div> -->
    <div class="Accumulatedamount">
      <div style="margin-left: -200px">
        <p>
          {{ $t("Myorder.Accumulatedamount")
          }}<img src="../../../assets/images/money.png" alt="" class="img" />
        </p>
        <p>{{ add.SumFree ? add.SumFree : 0 }}</p>
      </div>
      <div style="position: relative; left: 200px">
        <p>
          {{ $t("Myorder.Accumulatedweight")
          }}<img src="../../../assets/images/KG.png" alt="" class="img" />
        </p>
        <p>{{ add.SumWeight ? add.SumWeight : 0 }}</p>
      </div>
    </div>
    <!-- 全部订单 -->
    <div class="Allorders">
      <!-- tab -->
      <div style="margin: 14px 0 0 0; display: inline-block">
        <!-- {{active}} -->
        <Tabs
          active-key="key1"
          v-model="active"
          :animated="false"
          width="200px"
          class="tans"
          @on-click="changeTab"
        >
          <Tab-pane
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.txt"
          />
          <!-- + (item.total?count[item.total]:'') -->
        </Tabs>
      </div>
      <div class="game">
        <i-input
          v-model="search"
          :placeholder="$t('Myorder.Pleaseenter')"
          @on-change="changeSech()"
          style="width: 300px"
        ></i-input>
        <div class="background" @click="searchOrder()">
          <img src="../../../assets/images/sousuo.png" alt="" />
        </div>
      </div>
      <div class="tans">
        <div class="order">
          <div class="selelct">
            <i-select
              v-model="Time"
              :placeholder="$t('Myorder.qbdd')"
              style="width: 100px"
              @on-change="changeSelect"
            >
              <i-option
                :value="index"
                v-for="(item, index) in sel"
                :key="index"
                >{{ item }}</i-option
              >
            </i-select>
          </div>
          <p>{{ $t("Myorder.one") }}</p>
          <p style="position: relative; left: 134px">
            {{ $t("Personal.Consignee") }}
          </p>
          <div class="select1">
            <p>{{ $t("Myorder.two") }}</p>
          </div>
          <p style="position: relative; left: -21px">
            {{ $t("Myorder.therr") }}
          </p>
          <p style="position: relative; left: -69px">
            {{ $t("Myorder.four") }}
          </p>
        </div>
        <!-- 订单 -->
        <div v-if="allorder.length">
          <!-- Showaddorder -->
          <div v-for="(item, index) in allorder" :key="index">
            <div
              v-if="active == 0 && item.senttohk_state == '待付款'"
              class="ordernumber"
            >
              <div class="f1">
                <span>{{ item.order_time }} </span>
                <span style="margin-left: 35px"
                  >{{ $t("Myorder.Ordernumber") }}：<span
                    style="color: ##999999ff"
                    >{{ item.id }}</span
                  ></span
                >
                <span style="margin-left: 35px" v-if="item.is_senttohk == 1"
                  >{{ $t("Myorder.TranshipmentNo")
                  }}<span>{{ item.sent_kd_billcode }}</span></span
                >
                <span @click="GetLogisticsTrajectory(item.sent_kd_billcode)" class="addOneCx">{{ $t("Myorder.Logisticsinquiry") }}</span>
                <span @click="manageRecipients(item.id)" class="addOneCx addOneCx2">
                  {{ $t("Myorder.Recipients") }}
                </span>
                
                <img
                  src="../../../assets/images/shanchu.png"
                  alt=""
                  style="
                    width: 19px;
                    height: 22px;
                    vertical-align: middle;
                    position: absolute;
                    top: 9px;
                    left: 990px;
                    cursor: pointer;
                  "
                  @click="delAddress(item.id)"
                />
              </div>
              <div class="square">
                <div class="one">
                  <div class="squareQ">
                    <!-- 已发货待发货 -->
                    <img
                      src="../../../assets/images/1.png"
                      alt=""
                      style="width: 70px; height: 70px"
                      v-if="active == 0"
                    />
                    <!-- 已付款待付款 -->
                    <img
                      src="../../../assets/images/2.png"
                      alt=""
                      style="width: 70px; height: 70px"
                      v-if="active == 1"
                    />
                    <!-- 待签收已签收 -->
                    <img
                      src="../../../assets/images/3.png"
                      alt=""
                      style="width: 70px; height: 70px"
                      v-if="active == 2"
                    />
                    <!-- 已签收 -->
                    <img
                      src="../../../assets/images/5.png"
                      alt=""
                      style="width: 70px; height: 70px"
                      v-if="active == 3"
                    />
                    <p
                      class="Block_qs"
                      v-if="active == 3"
                      @click="SignAddress(item.id)"
                    >
                      确定签收
                    </p>
                    <!-- <button
                      class="Block_qs"
                      v-if="active == 3"
                      @click="SignAddress(item.id)"
                    >
                      确定签收
                    </button> -->
                  </div>
                  <div class="one_square">
                    <p>
                      {{ $t("Home.Weight") }}：<span
                        >{{ item.z_weight }}（kg）</span
                      >
                    </p>
                    <p>
                      {{ $t("Myorder.Prescription") }}：<span>{{
                        item.air_name
                      }}</span>
                    </p>
                    <p>
                      {{ $t("Myorder.cost") }}：<span>{{ item.Free }}</span>
                    </p>
                    <p>
                      {{ $t("Home.Topaid") }}：<span>{{ item.Dshk }}</span>
                    </p>
                    <p>
                      付款方式：<span>{{ item.pay_type }}</span>
                    </p>
                    <p>
                      {{ $t("Home.Shippingaddress") }}:<span>{{
                        item.address
                      }}</span>
                    </p>
                  </div>
                </div>
                <div class="two">
                  <div>{{ item.cname }}</div>
                  <div
                    v-if="active == 0 && item.pay_type != '货到付款'"
                    style="color: red"
                  >
                    {{ item.senttohk_state }}
                  </div>
                  <span
                    @click="handlePay(item)"
                    style="color: red; cursor: pointer"
                    v-if="
                      active == 0 &&
                      item.is_payed == 0 &&
                      item.pay_type != '货到付款'
                    "
                    >{{ $t("Continuetopay") }}</span
                  >
                  <span
                    v-if="active == 0 && item.pay_type == '货到付款'"
                    style="color: red"
                    >货到付款</span
                  >
                  <div>
                    <p style="text-align: center">{{ item.mobile }}</p>
                    <p style="text-align: center">{{ item.mobile2 }}</p>
                  </div>
                  <div>
                    <p @click="Dorer(item.id, item.air_name)">
                      {{ $t("Myorder.Orderdetails") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="active == 1 && item.senttohk_state == '待发货'"
              class="ordernumber"
            >
              <div class="f1">
                <span>{{ item.order_time }}</span>
                <span style="margin-left: 35px"
                  >{{ $t("Myorder.Ordernumber") }}：<span
                    style="color: ##999999ff"
                    >{{ item.id }}</span
                  ></span
                >
                <span style="margin-left: 35px" v-if="item.is_senttohk == 1"
                  >{{ $t("Myorder.TranshipmentNo")
                  }}<span>{{ item.sent_kd_billcode }}</span></span
                >
                <span
                  @click="GetLogisticsTrajectory(item.sent_kd_billcode)"
                  class="addOneCx"
                >
                  {{ $t("Myorder.Logisticsinquiry") }}
                </span>
                <span @click="manageRecipients(item.id)" class="addOneCx addOneCx2">
                  {{ $t("Myorder.Recipients") }}
                </span>

                <img
                  src="../../../assets/images/shanchu.png"
                  alt=""
                  style="
                    width: 19px;
                    height: 22px;
                    vertical-align: middle;
                    position: absolute;
                    top: 9px;
                    left: 990px;
                    cursor: pointer;
                  "
                  @click="delAddress(item.id)"
                />
              </div>
              <div class="square">
                <div class="one">
                  <div class="squareQ">
                    <!-- 已付款待付款 -->
                    <img
                      src="../../../assets/images/2.png"
                      alt=""
                      style="width: 70px; height: 70px"
                      v-if="active == 1"
                    />
                  </div>
                  <div class="one_square">
                    <p>
                      {{ $t("Home.Weight") }}：<span
                        >{{ item.z_weight }}（kg）</span
                      >
                    </p>
                    <p>
                      {{ $t("Myorder.Prescription") }}：<span>{{
                        item.air_name
                      }}</span>
                    </p>
                    <p>
                      {{ $t("Myorder.cost") }}：<span>{{ item.Free }}</span>
                    </p>
                    <p>
                      {{ $t("Home.Topaid") }}：<span>{{ item.Dshk }}</span>
                    </p>
                    <p>
                      付款方式：<span>{{ item.pay_type }}</span>
                    </p>
                    <p>
                      {{ $t("Home.Shippingaddress") }}:<span>{{
                        item.address
                      }}</span>
                    </p>
                  </div>
                </div>
                <div class="two">
                  <div>{{ item.cname }}</div>
                  <div style="color: red">{{ item.senttohk_state }}</div>
                  <!-- <div style="color: red" >
                    待發貨
                  </div> -->
                  <div>
                    <p style="text-align: center">{{ item.mobile }}</p>
                    <p style="text-align: center">{{ item.mobile2 }}</p>
                  </div>
                  <!-- <p
                    class="Block_qs"
                    v-if="item.senttohk_state == '待签收'"
                    @click="SignAddress(item.id)"
                  >
                    确定签收
                  </p> -->
                  <div>
                    <p @click="Dorer(item.id, item.air_name)">
                      {{ $t("Myorder.Orderdetails") }}
                    </p>
                    <!-- <p style="margin-top: 30px" v-if="item.is_senttohk==0">取消订单</p> -->
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="
                (active == 2 && item.senttohk_state == '待签收') ||
                item.senttohk_state == '已发货'
              "
              class="ordernumber"
            >
              <div class="f1">
                <span>{{ item.order_time }}</span>
                <span style="margin-left: 35px"
                  >{{ $t("Myorder.Ordernumber") }}：<span
                    style="color: ##999999ff"
                    >{{ item.id }}</span
                  ></span
                >
                <span style="margin-left: 35px" v-if="item.is_senttohk == 1"
                  >{{ $t("Myorder.TranshipmentNo")
                  }}<span>{{ item.sent_kd_billcode }}</span></span
                >
                <span
                  @click="GetLogisticsTrajectory(item.sent_kd_billcode)"
                  class="addOneCx"
                >
                  {{ $t("Myorder.Logisticsinquiry") }}
                </span>
                <span @click="manageRecipients(item.id)" class="addOneCx addOneCx2">
                  {{ $t("Myorder.Recipients") }}
                </span>
                <img
                  src="../../../assets/images/shanchu.png"
                  alt=""
                  style="
                    width: 19px;
                    height: 22px;
                    vertical-align: middle;
                    position: absolute;
                    top: 9px;
                    left: 990px;
                    cursor: pointer;
                  "
                  @click="delAddress(item.id)"
                />
              </div>
              <div class="square">
                <div class="one">
                  <div class="squareQ">
                    <img
                      src="../../../assets/images/2.png"
                      alt=""
                      style="width: 70px; height: 70px"
                      v-if="active == 2"
                    />
                    <p
                      class="Block_qs"
                      v-if="active == 2"
                      @click="SignAddress(item.id)"
                    >
                      确定签收
                    </p>
                  </div>
                  <div class="one_square">
                    <p>
                      {{ $t("Home.Weight") }}：<span
                        >{{ item.z_weight }}（kg）</span
                      >
                    </p>
                    <p>
                      {{ $t("Myorder.Prescription") }}：<span>{{
                        item.air_name
                      }}</span>
                    </p>
                    <p>
                      {{ $t("Myorder.cost") }}：<span>{{ item.Free }}</span>
                    </p>
                    <p>
                      {{ $t("Home.Topaid") }}：<span>{{ item.Dshk }}</span>
                    </p>
                    <p>
                      付款方式：<span>{{ item.pay_type }}</span>
                    </p>
                    <p>
                      {{ $t("Home.Shippingaddress") }}:<span>{{
                        item.address
                      }}</span>
                    </p>
                  </div>
                </div>
                <div class="two">
                  <div>{{ item.cname }}</div>
                  <div style="color: red">{{ item.senttohk_state }}</div>
                  <!-- <div v-if="active == 2" style="color: red">
                    {{ $t("Home.Tosigned") }}
                  </div> -->
                  <div>
                    <p style="text-align: center">{{ item.mobile }}</p>
                    <p style="text-align: center">{{ item.mobile2 }}</p>
                  </div>
                  <!-- <p
                    class="Block_qs"
                    v-if="item.senttohk_state == '待签收'"
                    @click="SignAddress(item.id)"
                  >
                    确定签收
                  </p> -->
                  <div>
                    <p @click="Dorer(item.id, item.air_name)">
                      {{ $t("Myorder.Orderdetails") }}
                    </p>
                    <!-- <p style="margin-top: 30px" v-if="item.is_senttohk==0">取消订单</p> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- || item.senttohk_state == '已发货' -->
            <div
              v-if="
                active == 3 &&
                item.senttohk_state == '已签收' &&
                item.senttohk_state != '已发货'
              "
              class="ordernumber"
            >
              <div class="f1">
                <span>{{ item.order_time }} </span>
                <span style="margin-left: 35px"
                  >{{ $t("Myorder.Ordernumber") }}：<span
                    style="color: ##999999ff"
                    >{{ item.id }}</span
                  ></span
                >
                <span style="margin-left: 35px" v-if="item.is_senttohk == 1"
                  >{{ $t("Myorder.TranshipmentNo")
                  }}<span>{{ item.sent_kd_billcode }}</span></span
                >
                <span
                  @click="GetLogisticsTrajectory(item.sent_kd_billcode)"
                  class="addOneCx"
                >
                  {{ $t("Myorder.Logisticsinquiry") }}
                </span>
                <span @click="manageRecipients(item.id)" class="addOneCx addOneCx2">
                  {{ $t("Myorder.Recipients") }}
                </span>
                <img
                  src="../../../assets/images/shanchu.png"
                  alt=""
                  style="
                    width: 19px;
                    height: 22px;
                    vertical-align: middle;
                    position: absolute;
                    top: 9px;
                    left: 990px;
                    cursor: pointer;
                  "
                  @click="delAddress(item.id)"
                />
              </div>
              <div class="square">
                <div class="one">
                  <div class="squareQ">
                    <img
                      src="../../../assets/images/5.png"
                      alt=""
                      style="width: 70px; height: 70px"
                      v-if="active == 3"
                    />
                  </div>
                  <div class="one_square">
                    <p>
                      {{ $t("Home.Weight") }}：<span
                        >{{ item.z_weight }}（kg）</span
                      >
                    </p>
                    <p>
                      {{ $t("Myorder.Prescription") }}：<span>{{
                        item.air_name
                      }}</span>
                    </p>
                    <p>
                      {{ $t("Myorder.cost") }}：<span>{{ item.Free }}</span>
                    </p>
                    <p>
                      {{ $t("Home.Topaid") }}：<span>{{ item.Dshk }}</span>
                    </p>
                    <p>
                      付款方式：<span>{{ item.pay_type }}</span>
                    </p>
                    <p>
                      {{ $t("Home.Shippingaddress") }}:<span>{{
                        item.address
                      }}</span>
                    </p>
                  </div>
                </div>
                <div class="two">
                  <div>{{ item.cname }}</div>
                  <div style="color: red">
                    {{ item.senttohk_state }}
                  </div>
                  <div>
                    <p style="text-align: center">{{ item.mobile }}</p>
                    <p style="text-align: center">{{ item.mobile2 }}</p>
                  </div>
                  <div>
                    <p @click="Dorer(item.id, item.air_name)">
                      {{ $t("Myorder.Orderdetails") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="active == 4" class="ordernumber">
              <div class="f1">
                <span>{{ item.order_time }} </span>
                <span style="margin-left: 35px"
                  >{{ $t("Myorder.Ordernumber") }}：<span
                    style="color: ##999999ff"
                    >{{ item.id }}</span
                  ></span
                >
                <span style="margin-left: 35px" v-if="item.is_senttohk == 1"
                  >{{ $t("Myorder.TranshipmentNo")
                  }}<span>{{ item.sent_kd_billcode }}</span></span
                >
                <span
                  @click="GetLogisticsTrajectory(item.sent_kd_billcode)"
                  class="addOneCx"
                >
                  {{ $t("Myorder.Logisticsinquiry") }}
                </span>
                <span @click="manageRecipients(item.id)" class="addOneCx addOneCx2">
                  {{ $t("Myorder.Recipients") }}
                </span>
                <img
                  src="../../../assets/images/shanchu.png"
                  alt=""
                  style="
                    width: 19px;
                    height: 22px;
                    vertical-align: middle;
                    position: absolute;
                    top: 9px;
                    left: 990px;
                    cursor: pointer;
                  "
                  @click="delAddress(item.id)"
                />
              </div>
              <div class="square">
                <div class="one">
                  <div class="squareQ">
                    <!-- <img src="../../../assets/images/5.png" alt="" style="width: 70px; height: 70px" v-if="active == 3 "/> -->
                  </div>
                  <div class="one_square">
                    <p>
                      {{ $t("Home.Weight") }}：<span
                        >{{ item.z_weight }}（kg）</span
                      >
                    </p>
                    <p>
                      {{ $t("Myorder.Prescription") }}：<span>{{
                        item.air_name
                      }}</span>
                    </p>
                    <p>
                      {{ $t("Myorder.cost") }}：<span>{{ item.Free }}</span>
                    </p>
                    <p>
                      {{ $t("Home.Topaid") }}：<span>{{ item.Dshk }}</span>
                    </p>
                    <p>
                      付款方式：<span>{{ item.pay_type }}</span>
                    </p>
                    <p>
                      {{ $t("Home.Shippingaddress") }}:<span>{{
                        item.address
                      }}</span>
                    </p>
                  </div>
                </div>
                <div class="two">
                  <div>{{ item.cname }}</div>
                  <div style="color: red">
                    {{ item.senttohk_state }}
                  </div>
                  <div>
                    <p style="text-align: center">{{ item.mobile }}</p>
                    <p style="text-align: center">{{ item.mobile2 }}</p>
                  </div>
                  <div>
                    <p @click="Dorer(item.id, item.air_name)">
                      {{ $t("Myorder.Orderdetails") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="allorder.length == 0" class="shuju">
          {{ $t("Nodataatpresent") }}
        </div>
      </div>
      <!-- <div class="notshippedsum">({{count.notshippedsum}})</div> -->
    </div>
    <!-- 删除对话框 -->
    <Modal
      v-model="handelModal"
      title="確認取消?"
      :loading="handelloading"
      @on-cancel="cuurrtAddressID = null"
      @on-ok="ClearOrder"
    >
      <p>{{ $t("canceltheorder") }}</p>
    </Modal>
    <!-- 确定签收对话框 -->
    <Modal
      v-model="handelModalSignfor"
      title="確認签收订单?"
      :loading="handelModalSignfording"
      @on-cancel="handelModalSignforID = null"
      @on-ok="Add_Sign"
    >
      <p>確認簽收訂單嗎?</p>
    </Modal>
    <r-mask :title="title" :isShowModal="isPay" @closeMask="isPayFn">
      <div class="payBox">
        <div>{{ $t("Home.Paymentamount") }}：{{ this.payMoneny }}元</div>
        <br />
        <Select
          v-model="model1"
          style="width: 200px"
          @on-change="changeAddress"
        >
          <Option
            v-for="item in payList"
            :value="item.id"
            :key="item.id"
            :label="item.pay"
          ></Option>
        </Select>
        <!-- <Button-b @click.native="Go_QFPay" value="确定"></Button-b> -->
        <Button type="primary" @click="AddorderText()">确定</Button>
        <!-- <p style="color: red; font-size: 14px; margin-top: 5px" v-show="Shwozhu">
          注：(支付寶,微信,轉數快支付會收取1%手績費，使用PAYPAL會有手續費3.9%+$2.35手續費產生)
        </p> -->
        <!-- <button  class="PayButton"></button> -->
        <!-- 支付宝 -->
        <div v-show="Shwozfb">
          <br />
          <iframe
            class="wuliu"
            :src="zfbUrl"
            width="400"
            height="800"
            scrolling="no"
            sandbox="allow-forms allow-scripts allow-same-origin allow-popups"
          ></iframe>
        </div>
        <!-- 微信 -->
        <div v-if="Showwx">
          <div class="tip01">{{ $t("Home.codebelow") }}</div>
          <div id="WeChie" style="margin: 10px 0 0 170px"></div>
          <!-- <img :src="'data:image/png;base64,'+Familywx" alt="图片未上传" /> -->
          <div class="tip02">
            {{ $t("Home.Paymentamount") }}：{{ this.payMoneny }}元
          </div>
        </div>
        <div v-show="Showtb" class="taobao">
          <div class="tip01">
            {{ $t("Mypackage.Paymentcode") }}:<span
              style="color: red; cursor: pointer"
              >{{ orderAll }}</span
            >
          </div>
          <Button-b
            :value="$t('Home.copy')"
            @click.native="copy"
            v-clipboard="orderAll"
            style="width: 200px; margin: 2px 0 0 200px"
          ></Button-b>
          <div class="linktaobao" @click="toLink">
            {{ $t("Mypackage.payTaobao") }}
          </div>
          <div class="tip02">
            {{ $t("Home.Paymentamount") }}：{{ this.payMoneny }}元
          </div>
        </div>
        <!-- 轉數快 -->
        <div v-show="Shwozsk">
          <div class="tip01">請打開轉數快掃描下方二維碼</div>
          <img
            :src="'data:image/png;base64,' + Familyzsk"
            alt="图片未上传"
            style="margin: 10px 0 0 170px"
          />
          <div class="tip02">
            {{ $t("Home.Paymentamount") }}：{{ this.payMoneny }}元
          </div>
        </div>

        <div class="pay-top">
          <!-- <div>余额支付方式：</div> -->
          <Button-b
            @click.native="Deduction"
            :value="$t('Balancepayment')"
          ></Button-b>
        </div>
      </div>
    </r-mask>

    <!-- 管理申报人 -->
    <r-mask :title="$t('Myorder.Recipients')"  :isShowModal="recipientShow" @closeMask="recipientShow = false" class="addMask">
      <div class="goods" @click="addDeclarant">{{ $t("Myorder.AddDeclarant") }}</div>
      <i-table :columns="columns" border :data="tableData" align="center" id="Tbaleone"></i-table>
    </r-mask>

    <!-- 添加申报人 -->
    <r-mask :title="$t('Myorder.AddDeclarant')"  :isShowModal="declarantShow" @closeMask="declarantShow = false" class="addMask2">
      <i-table :columns="declarantCol" border :data="tableData2" align="center" id="Tbaleone"  @on-selection-change="handleSelect"></i-table>
      <Page :total="AllCount" :current="pageNo" :page-size="pageSize" @on-change="onpage" show-total show-elevator/>
      <div class="goods goods2" @click="addSubmit">{{ $t("Home.Submit") }}</div>
    </r-mask>

    <!-- :title="`单号:${arr.length ? arr[0].name : ''}物流状态`" -->
    <r-mask
      :title="$t('Logisticsstatus')"
      :isShowModal="isShowState"
      @closeMask="isShowState = false"
    >
      <!-- <i-table stripe :columns="columns1" :data="arr.length ? arr[0].value : []" align="center" id="mygrid"></i-table> -->
      <!-- <table v-for="(item,key) in arr" :key="key" class="center" v-if="arr.length">
            <h2 style="color:red">{{$t('OperationorderNo')}}：{{item.name}}</h2>
            <tr class="Tr">
              <td>{{$t('ClTime')}}</td>
              <td>{{$t('Clinformation')}}</td>
            </tr>
            <tr v-for="(v,index) in item.value" :key="index" class="Tr">
              <td>{{v.scan_time}}</td>
              <td>{{v.scan_memo}}</td>
            </tr>
          </table> -->
      <!-- v-if="arr.length" -->
      <Timeline
        v-for="(item, key) in arr"
        :key="key"
        v-if="arr.length"
        class="center"
      >
        <h2 style="color: red">运转单号：{{ arr[key].name }}</h2>
        <br />
        <TimelineItem v-for="(v, index) in item.value" :key="index" class="Tr">
          <div>
            <p>{{ v.scan_time }}</p>
            <p>{{ v.scan_memo }}</p>
          </div>
        </TimelineItem>
      </Timeline>
      <h1 v-if="arr.length == 0" class="shuju">
        {{ $t("Nodataatpresent") }}
      </h1>
    </r-mask>
    <!-- <div style="width:200px;height:200px;background:red">
      <Select v-model="model1" style="width: 200px" @on-change="changeAddress">
        <Option v-for="item in payList" :value="item.id" :key="item.id" :label="item.pay"></Option>
      </Select>
    </div> -->
  </div>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      sl: false,
      columns1: [
        {
          title: "處理時間",
          key: "scan_time",
        },
        {
          title: "處理信息",
          key: "scan_memo",
        },
      ],
      select: "",
      order: "",
      allorder: [],
      arr: [],
      statusList: [
        {
          label: "待付款",
          key: 0,
          type: "IsPayed",
          // total: null,
        },
        {
          label: "待發貨",
          key: 1,
          type: "IsComment",
          // total: "pementsum",
        },
        {
          label: "待簽收",
          key: 2,
          type: "IsQs",
          // total: "notshippedsum",
        },
        {
          label: `已簽收`,
          key: 3,
          type: null,
          // total: "is_cus_qssum",
        },
        {
          label: `全部`,
          key: 4,
          type: null,
          // total: "is_cus_qssum",
        },
      ],
      count: {},
      sel: ["全部", "今天", "昨天", "壹周", "壹月"],
      all: [],
      Time: "",
      params: {
        MemberID: localStorage.getItem("userID"),
        limit: 80,
        offset: 1,
        IsPayed: 0,
        IsConfirm: 1,
        IsQs: 1,
        IsComment: 1,
        StartTime: "",
        EndTime: "",
      },

      // this.params["IsPayed"] = 0;
      //     this.params["IsQs"] = 1;
      //     this.params["IsComment"] = 1;
      add: {},
      search: "",
      dange: [],
      handelModal: false,
      handelloading: false,
      handelModalSignfor: false,
      handelModalSignfording: false,
      handelModalSignforID: null,
      cuurrtAddressID: null,
      active: 0,
      isPay: false,
      zfbUrl: "",
      payKey: "-1",
      payMoneny: 0,
      title: `訂單繼續支付`,
      OrderID: "",
      Money: "",
      time: "",
      odd: "",
      isShowState: false,
      recipientShow: false,
      tableData: [],
      orderId: "",
      declarantShow: false,
      tableData2: [],
      pageNo:1,
      AllCount:0,
      pageSize:10,
      addDeclarantIds: "",
      url: "",
      signFor: [],
      orderAll: "",
      sddd: "",
      PayType: "",
      payList: [
        { id: 3, pay: "淘寶店支付" },
        { id: 4, pay: "轉賬" },
        // { id: 23, pay: "轉數快" },
        // { id: 24, pay: "支付寶香港" },
        // { id: 21, pay: "微信支付香港" },
        // { id: 66, pay: "PAYPAL/信用卡" },
        // { id: 0, pay: "微信支付" },
        // { id: 1, pay: "支付寶支付" },
      ],
      model1: "",
      payID: 0, // 支付id ,
      Familyzsk: "",
      Familywx: "",
      Shwozsk: false,
      Shwozfb: false,
      Showwx: false,
      Familywx: "",
      Showtb: false,
      payName: "",
      timer: "",
      Shwozhu: false,
      SHowdd: [],
      PayIDone: 0,
      Showaddorder: [],
      linkeTime: "",
      taoBaoUrl: localStorage.getItem('TaoBaoUrl')
    };
  },
  mounted() {
    this.OrderRecordPage();
    // this.getInfo();
    this.queryorderquantity();
  },
  watch: {
    $route() {
      if (this.$route.query && this.$route.query.type) {
        this.changeTab(parseInt(this.$route.query.type));
      }
    },
    iframeUrl() {
      var iframe = document.getElementById("frame");
      iframe.onload = function (e) {
        console.log("页面跳转");
      };
    },
  },
  created() {
    if (this.$route.query && this.$route.query.type) {
      this.changeTab(parseInt(this.$route.query.type));
    }
  },
  computed: {
    columns() {
      return [
        {
          key: "RName",
          title: this.$t("Myorder.AddresseeName"),
          align: "center",
          width: 140
        },
        {
          key: "Tel",
          title: this.$t("Myorder.AddresseeTel"),
          align: "center"
        },
        {
          key: "RIDNumber",
          title: this.$t("Myorder.AddresseeRIDNumber"),
          align: "center"
        },
        {
          title: this.$t("Declarant.operation"),
          fixed: "right",
          align: "center",
          width: 120,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  //   这是点击事件
                  on: {
                    click: () => {
                      this.remove(params);
                    },
                  },
                },
                this.$t("Declarant.delete")
              ),
            ]);
          },
        },
      ]
    },
    declarantCol() {
      return [
        {
          type: "selection",
          width: 60,
          align: 'center'
        },
        {
          key: "RName",
          title: this.$t("Myorder.AddresseeName"),
          align: "center",
          width: 120
        },
        {
          key: "Tel",
          title: this.$t("Myorder.AddresseeTel"),
          align: "center"
        },
        {
          key: "RIDNumber",
          title: this.$t("Myorder.AddresseeRIDNumber"),
          align: "center"
        }
      ]
    }
  },
  methods: {
    // async OrderRecordPage_JYSJ() {
    //   const params = {
    //     MemberID: localStorage.getItem("userID"),
    //     limit: 80,
    //     offset: 1,
    //     IsConfirm: 1,
    //     IsPayed: 1,
    //     IsQs: 1,
    //     IsComment: 1,
    //   };
    //   const { data } = await this.$post("OrderRecordPage_JYSJ", params);
    //   if (data.State) {
    //     this.SHowdd = JSON.parse(data.ReturnJson);
    //   }
    // },
    async getInfo() {
      const params = {
        MemberID: localStorage.getItem("userID"),
        limit: 80,
        offset: 1,
        IsConfirm: 1,
        IsPayed: 1,
        IsQs: 1,
        IsComment: 1,
      };
      const { data } = await this.$post("OrderRecordPage", params);
      if (data.State) {
        this.signFor = JSON.parse(data.ReturnJson);
        this.queryorderquantity();
      }
    },
    // 管理申报人
    manageRecipients(id) {
      this.orderId = id
      this.getHaveDeclarant()
      this.recipientShow = true
    },
    //查询已有的申报人
    getHaveDeclarant() {
      let JsonData = {
        MemberId: localStorage.getItem("userID"),
        OrderID: this.orderId
      };
      this.$post('/QueryOrderReciver',JsonData).then((res) => {
        if(res.data.State) {
          this.tableData =  JSON.parse(res.data.ReturnJson)
        } else {
          this.$Message.error(res.data.MsgText)
        }
      })
    },

    // 删除申报人
    remove(row) {
      this.$Modal.confirm({
        title: "提示",
        content: `確定要刪除此申报人嗎？`,
        onOk: () => {
          this.del(row);
        },
        onCancel: () => {
          this.$Message.info("取消操作");
        },
      });
    },
    del(row) {
      let params = {
        ReciversId: row.row.ID,
        MemberId: localStorage.getItem("userID"),
        OrderID: this.orderId
      }
      this.$post('/DeleteReciverByOrder',params).then((res) => {
        if(res.data.State) {
          this.$Message.success("已刪除此申報人");
          this.getHaveDeclarant();
        } else {
          this.$Message.error(res.data.MsgText);
        }
      })
    },

    //点击添加申报人
    addDeclarant() {
      this.getNoAddDeclarantList()
    },
    //查询不属于当前订单的申报人
    getNoAddDeclarantList() {
      let params = {
        MemberId: localStorage.getItem("userID"),
        OrderID: this.orderId,
        offset: (this.pageNo - 1) * this.pageSize, // 每页条数
        limit: this.pageSize,   // 第几页
      }
      this.$post('/QueryReciver',params).then((res) => {
        if (res.data.State) {
          this.tableData2 = JSON.parse(res.data.ReturnJson).ReceiverInfo;
          this.AllCount = JSON.parse(res.data.ReturnJson).AllCount;
          this.declarantShow = true
        } else {
          this.$Message.error(res.data.MsgText)
        }
      })
    },
    onpage(pageNo){
      this.pageNo = pageNo;
      this.getNoAddDeclarantList();
    },
    handleSelect(item) {
      let ids = ""
      item.forEach((item) => {
        ids = ids + item.ID + ','
      });
      var reg = /,$/gi
      ids = ids.replace(reg,"")
      this.addDeclarantIds = ids
    },
    //提交添加申报人
    addSubmit() {
      if(this.addDeclarantIds) {
        let params = {
          MemberID: localStorage.getItem("userID"),
          ReciversId: this.addDeclarantIds,
          OrderID: this.orderId
        }
        this.$post('/UpdateReciverByOrder',params).then((res) => {
          if(res.data.State) {
            this.getHaveDeclarant()
            this.$Message.success("添加申報人成功！")
            this.declarantShow = false
          } else {
            this.$Message.error(res.data.MsgText)
          }
        })
      } else {
        this.$Message.error("請選擇要添加的申報人！")
      }
    },
    async GetLogisticsTrajectory(code) {
      let _this = this;
      this.arr = [];
      const params = {
        MemberID: localStorage.getItem("userID"),
        billcodelist: code,
        token: localStorage.getItem("token"),
      };
      _this.isShowState = true;
      const { data } = await this.$post("GetLogisticsTrajectory", params, true);
      if (data.State) {
        this.allorder = JSON.parse(data.ReturnJson);
      }
      let obj = JSON.parse(data.ReturnJson);
      Object.keys(obj).forEach((key, index) => {
        _this.arr.push({
          name: key,
          value: JSON.parse(obj[key]),
        });
      });
      console.log(this.arr, "arr===========");
    },
    isShow() {
      this.show = false;
    },
    isPayFn() {
      this.isPay = false;
      this.payID = 0;
      (this.Shwozsk = false),
        (this.Shwozfb = false),
        (this.Showwx = false),
        (this.Showtb = false),
        (this.payList.pay = "請選擇付款方式");
      console.log(this.payID);
      console.log(this.payList.pay);
    },
    changeAddress(vId) {
      let obj = {};
      obj = this.payList.find((item) => {
        return item.id === vId;
      });
      this.payID = obj.id;
      this.payName = obj.pay;
      // if (this.payID == 3) {
      //   this.Shwozhu = false;
      // } else {
      //   this.Shwozhu = true;
      // }
      this.PayIDone = this.payID;
      console.log(this.payID, "this.payID");
      console.log(this.payName);
    },
    AddorderText() {
      this.PayIDone = this.payID;
      // this.payName = obj.pay;
      if (this.PayIDone == 0 || this.PayIDone == 1) {
        // this.Go_QFPay();
        this.continuePay_Order();
      } else if (this.PayIDone == 3) {
        window.open(this.taoBaoUrl);
      }  if (this.PayIDone == 4) {
         this.isPay = false;
        console.log(this.payMoneny, "你是多少", this.orderAll);
        // localStorage.setItem("TransactionNo",this.orderAll)
        // localStorage.setItem("Money",this.payMoneny)
        this.$router.push({
          path: "/bankTransfer",
           query: { msg2: this.payMoneny,msg3: this.orderAll }
        });
      } else {
        this.PayPal_Pay();
      }
      console.log(this.payID, "this.payID");
      console.log(this.payName);
    },
    changeTab(e) {
      const v = this.statusList[e];
      this.active = e;
      console.log(this.active, "activeactiveactive");
      switch (e) {
        case 0:
          this.params["IsPayed"] = 0;
          this.params["IsQs"] = 1;
          this.params["IsComment"] = 1;
          this.OrderRecordPage();
          break;
        case 1:
          this.params["IsPayed"] = 1;
          this.params["IsQs"] = 1;
          this.params["IsComment"] = 0;
          this.OrderRecordPage();
          break;
        case 2:
          this.params["IsPayed"] = 1;
          this.params["IsQs"] = 0;
          this.params["IsComment"] = 1;
          this.OrderRecordPage();
          break;
        case 3:
          this.params["IsConfirm"] = 1;
          this.params["IsPayed"] = 1;
          this.params["IsQs"] = 1;
          this.params["IsComment"] = 1;
          this.OrderRecordPage();
          break;
        case 4:
          this.params["IsConfirm"] = 1;
          this.params["IsPayed"] = 1;
          this.params["IsQs"] = 1;
          this.params["IsComment"] = 1;
          this.OrderRecordPage();
          break;
      }
    },
    changeSelect(e) {
      this.selDate(e);
    },
    handlePay(e) {
      this.orderAll = e.order_code;
      this.isPay = true;
      this.payMoneny = e.Free;
      this.OrderID = e.id;
      this.Money = e.Free;
      // if(this.payKey == 0 || this.payKey==1) {
      //   this.Go_QFPay()s
      // }let obj = {};
    },
    // 录入签收
    async Add_Sign() {
      const params = {
        MemberID: localStorage.getItem("userID"),
        ID: this.handelModalSignforID,
      };
      const { data } = await this.$post("Add_Sign", params);
      if (data.State) {
        this.$Message.success("签收成功");
        this.OrderRecordPage();
      }
      this.$Message.success(data.MsgText);
    },
    SignAddress(value) {
      this.handelModalSignfor = true;
      this.handelModalSignforID = value;
    },
    //查询订单数量
    async queryorderquantity() {
      const params = { MemberID: localStorage.getItem("userID") };
      const { data } = await this.$post("Queryorderquantity", params);
      if (data.State) {
        this.count = JSON.parse(data.ReturnJson)[0];
        this.statusList = this.statusList.map((item, index) => {
          // item.num = item.total ? this.count[item.total] : this.signFor.length; (${item.num})
          item.txt = `${item.label}`;
          return item;
        });
      }
    },
    // 查询所有订单
    // async OrderRecordPage() {
    //   this.allorder = [];
    //   const { data } = await this.$post("OrderRecordPage", this.params);
    //   if (data.State) {
    //     this.allorder = JSON.parse(data.ReturnJson);
    //     this.add = this.allorder.length && JSON.parse(data.ReturnJson)[0];
    //     this.statusList[0].num = this.allorder.length;
    //     this.sddd = this.allorder = JSON.parse(data.ReturnJson);
    //     // console.log(this.sddd.goodsType,"allorderallorderallorderallorder")
    //   }
    // },
    async OrderRecordPage() {
      this.allorder = [];
      const { data } = await this.$post("OrderRecordPage", this.params);
      if (data.State) {
        this.allorder = JSON.parse(data.ReturnJson);
        this.add = this.allorder.length && JSON.parse(data.ReturnJson)[0];
        this.statusList[0].num = this.allorder.length;
        this.sddd = this.allorder = JSON.parse(data.ReturnJson);
        this.Showaddorder = this.allorder.filter((item) => {
          return item.senttohk_state == "已签收";
        });
        // console.log(this.sddd.goodsType,"allorderallorderallorderallorder")
      }
    },
    // 删除订单
    async ClearOrder() {
      const params = {
        MemberID: localStorage.getItem("userID"),
        ID: this.cuurrtAddressID,
      };
      const { data } = await this.$post("ClearOrder", params);
      if (data.State) {
        this.OrderRecordPage();
        this.queryorderquantity();
        this.$Message.success("删除成功！");
      } else {
        this.$Message.error(data.MsgText);
      }
    },

    // //  payList: [
    //     // { id: 3, pay: "淘寶店支付" },
    //     { id: 23, pay: "轉數快" },
    //     { id: 24, pay: "支付寶香港" },
    //     { id: 21, pay: "微信支付香港" },
    //     { id: 66, pay: "PAYPAL/信用卡" },
    //     // { id: 11, pay: "微信支付" },
    //     // { id: 12, pay: "支付寶支付" },
    //   ],
    async continuePay_Order() {
      this.$Spin.show({
        render: (h) => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 22,
              },
            }),
            h("div", "正在加載請稍後"),
          ]);
        },
      });
      var myDate = new Date();
      var myYear = myDate.getFullYear(); // 获取当前年份
      var myMonth = myDate.getMonth() + 1; // 获取当前月份
      myMonth = myMonth < 10 ? "0" + myMonth : myMonth;
      var myDay = myDate.getDate(); // 获取当前日（1- 31）
      myDay = myDay < 10 ? "0" + myDay : myDay;
      var myHours = myDate.getHours(); // 获取当前小时(0-23)
      var myMinu = myDate.getMinutes(); // 获取当前分钟(0-59)
      var mySec = myDate.getSeconds(); // 获取当前秒数(0-59)
      var mymil = myDate.getMilliseconds(); // 获取当前毫秒数(0-59)
      var time =
        myYear +
        "" +
        myMonth +
        "" +
        myDay +
        "" +
        myHours +
        "" +
        myMinu +
        "" +
        mySec +
        "" +
        mymil;
      this.time = time;
      var zfb = "ali";
      var H = "H";
      var wx = "wx";
      // linkeTime
      if (this.payID == 0) {
        this.linkeTime = wx + this.time + H + this.OrderID;
      } else if (this.payID == 1) {
        this.linkeTime = zfb + this.time + H + this.OrderID;
      }
      // return false;
      var JsonData1 = {
        // OpenID:"",
        // PayTypeID: this.payKey == 0 ? 3 : 0,  //0：微信扫码支付 1：微信JSAPI支付 2:微信小程序JSAPI支付 3.支付宝
        // OrderId: this.OrderID,
        // Name: this.payID,
        // PayMode: this.payKey == 0? 1:0 ,//0 微信支付 1 支付宝支付 默认 0
        // IsQrCode: 0, //支付宝是否二维码模式 0
        // OrderCode: time,
        // Rem: this.OrderID,
        OpenID: this.OrderID,
        PayTypeID: this.payID == 0 ? 3 : 0, //0：微信扫码支付 1：微信JSAPI支付 2:微信小程序JSAPI支付 3.支付宝
        OrderId: this.OrderID,
        PayMode: this.payID, //0 微信支付 1 支付宝支付 默认 0
        IsQrCode: 0, //支付宝是否二维码模式 0
        Money: this.Money,
        ClientCode: localStorage.getItem("userID"),
        GoodsName: "支付",
        OrderCode: this.linkeTime,
        Rem: this.OrderID,
      };
      const { data } = await this.$post("continuePay_Order", JsonData1);
      if (data.State) {
        this.$Spin.hide();
        // this.isPay = true
        //   this.zfbUrl = data.ReturnJson;
        //   document.getElementById("WeChie").innerHTML = "";
        //   let WeChie = new QRCode("WeChie", {
        //     width: 150,
        //     height: 150,
        //     text: data.ReturnJson, // 二维码地址
        //     colorDark: "#000",
        //     colorLight: "#fff",
        //   });
        if (this.payID == 1) {
          this.Shwozfb = true;
          this.Showwx = false;
          (this.Shwozsk = false),
            (this.Showtb = false),
            (this.zfbUrl = data.ReturnJson);
          this.timer = setInterval(this.QueryOrderState, 2000);
        }
        //  微信
        if (this.payID == 0) {
          this.Showwx = true;
          (this.Shwozsk = false),
            (this.Shwozfb = false),
            (this.Showtb = false),
            this.$nextTick(() => {
              document.getElementById("WeChie").innerHTML = "";
              let WeChie = new QRCode("WeChie", {
                width: 150,
                height: 150,
                text: data.ReturnJson, // 二维码地址
                colorDark: "#000",
                colorLight: "#fff",
              });
            });
          this.timer = setInterval(this.QueryOrderState, 2000);
          //  this.Familywx = data.ReturnJson
        }
        if (this.payID == 3) {
          window.open(this.taoBaoUrl);
          this.Showtb = true;
          this.Showwx = false;
          this.Shwozsk = false;
          this.Shwozfb = false;
          return false;
        }
        if (this.payID == 4) {
          this.isPay = false;
          console.log(this.payMoneny, "你是多少", this.orderAll);
          // localStorage.setItem("TransactionNo",this.orderAll)
          // localStorage.setItem("Money",this.payMoneny)
          this.$router.push({
            path: "/bankTransfer",
            query: { msg2: this.payMoneny, msg3: this.orderAll },
          });
        }

        // if (this.payID == 12) {
        // 支付宝支付
        // this.$router.push("./myOrder");
        // window.open(data.MsgText);
        // this.PayPal_Pay();
        // }
        // this.$Message.error(data.MsgText)
        //  if(this.payKey == 1){
        //     document.getElementById("WeChie").innerHTML = "";
        //     let WeChie = new QRCode("WeChie", {
        //       width: 150,
        //       height: 150,
        //       text: data.ReturnJson, // 二维码地址
        //       colorDark: "#000",
        //       colorLight: "#fff",
        //     });
        //  }
      }
    },
    async Go_QFPay() {
      this.$Spin.show({
        render: (h) => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 22,
              },
            }),
            h("div", "正在加載請稍後"),
          ]);
        },
      });
      var myDate = new Date();
      var myYear = myDate.getFullYear(); // 获取当前年份
      var myMonth = myDate.getMonth() + 1; // 获取当前月份
      myMonth = myMonth < 10 ? "0" + myMonth : myMonth;
      var myDay = myDate.getDate(); // 获取当前日（1- 31）
      myDay = myDay < 10 ? "0" + myDay : myDay;
      var myHours = myDate.getHours(); // 获取当前小时(0-23)
      var myMinu = myDate.getMinutes(); // 获取当前分钟(0-59)
      var mySec = myDate.getSeconds(); // 获取当前秒数(0-59)
      var mymil = myDate.getMilliseconds(); // 获取当前毫秒数(0-59)
      var time =
        myYear +
        "" +
        myMonth +
        "" +
        myDay +
        "" +
        myHours +
        "" +
        myMinu +
        "" +
        mySec +
        "" +
        mymil;
      this.time = time;
      var JsonData1 = {
        // OpenID:"",
        // PayTypeID: this.payKey == 0 ? 3 : 0,  //0：微信扫码支付 1：微信JSAPI支付 2:微信小程序JSAPI支付 3.支付宝
        OrderId: this.OrderID,
        Name: this.payID,
        // PayMode: this.payKey == 0? 1:0 ,//0 微信支付 1 支付宝支付 默认 0
        // IsQrCode: 0, //支付宝是否二维码模式 0
        // OrderCode: time,
        // Rem: this.OrderID,
      };
      const { data } = await this.$post("Go_QFPay", JsonData1);
      if (data.State) {
        this.$Spin.hide();
        console.log(this.payID, "zhifuthis.payID");
        // this.isPay = true
        //   this.zfbUrl = data.ReturnJson;
        //   document.getElementById("WeChie").innerHTML = "";
        //   let WeChie = new QRCode("WeChie", {
        //     width: 150,
        //     height: 150,
        //     text: data.ReturnJson, // 二维码地址
        //     colorDark: "#000",
        //     colorLight: "#fff",
        //   });
        // 轉速快
        if (this.payID == 23) {
          this.Shwozsk = true;
          this.Shwozfb = false;
          this.Showwx = false;
          (this.Showtb = false), (this.Familyzsk = data.ReturnJson);
          this.timer = setInterval(this.QueryOrderState, 2000);
        }
        if (this.payID == 12) {
          this.Shwozfb = true;
          this.Showwx = false;
          (this.Shwozsk = false),
            (this.Showtb = false),
            (this.zfbUrl = data.ReturnJson);
          this.timer = setInterval(this.QueryOrderState, 2000);
        }
        //  微信
        if (this.payID == 11) {
          this.Showwx = true;
          (this.Shwozsk = false),
            (this.Shwozfb = false),
            (this.Showtb = false),
            this.$nextTick(() => {
              document.getElementById("WeChie").innerHTML = "";
              let WeChie = new QRCode("WeChie", {
                width: 150,
                height: 150,
                text: data.ReturnJson, // 二维码地址
                colorDark: "#000",
                colorLight: "#fff",
              });
            });
          this.timer = setInterval(this.QueryOrderState, 2000);
          //  this.Familywx = data.ReturnJson
        }
        if (this.payID == 3) {
          window.open(this.taoBaoUrl);
          this.Showtb = true;
          this.Showwx = false;
          this.Shwozsk = false;
          this.Shwozfb = false;
          return false;
        }
        if (this.payID == 12) {
          // 支付宝支付
          // this.$router.push("./myOrder");
          // window.open(data.MsgText);
          // this.PayPal_Pay();
        }
        if (this.payID == 4) {
          this.isPay = false;
          console.log(this.payMoneny, "你是多少", this.orderAll);
          // localStorage.setItem("TransactionNo",this.orderAll)
          // localStorage.setItem("Money",this.payMoneny)
          this.$router.push({
            path: "/bankTransfer",
            query: { msg2: this.payMoneny, msg3: this.orderAll },
          });
        }
        // this.$Message.error(data.MsgText)
        //  if(this.payKey == 1){
        //     document.getElementById("WeChie").innerHTML = "";
        //     let WeChie = new QRCode("WeChie", {
        //       width: 150,
        //       height: 150,
        //       text: data.ReturnJson, // 二维码地址
        //       colorDark: "#000",
        //       colorLight: "#fff",
        //     });
        //  }
      }
    },
    async PayPal_Pay() {
      this.$Spin.show({
        render: (h) => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 22,
              },
            }),
            h("div", "正在加載請稍後"),
          ]);
        },
      });
      var JsonData = {
        MemberID: localStorage.getItem("userID"),
        OrderId: this.OrderID,
        cancel_url: "https://member.shengdaexp.com/#/myOrder",
        return_url: "https://member.shengdaexp.com/#/myOrder",
      };
      const { data } = await this.$post("PayPal_Pay", JsonData);
      if (data.State) {
        this.$Spin.hide();
        window.open(data.ReturnJson);
      }
    },
    async QueryOrderState() {
      var JsonData = {
        OrderId: this.OrderID,
      };
      const { data } = await this.$post("QueryOrderState", JsonData);
      if (data.State) {
        this.isPay = false;
        this.$Message.success("支付成功！");
        window.clearInterval(this.timer);
      }
    },
    delAddress(value) {
      this.handelModal = true;
      this.cuurrtAddressID = value;
    },
    async Deduction() {
      var params = {
        Id: this.OrderID,
        MemberId: localStorage.getItem("userID"),
      };
      // debugger
      const { data } = await this.$post("Deduction", params);
      if (data.State) {
        this.isPay = false;
        this.$Message.success("支付成功！");
        this.OrderRecordPage();
        this.queryorderquantity();
      } else {
        this.$Message.error(this.MsgText);
      }
    },
    //单个订单详细
    Dorer(ID, air_name) {
      this.$router.push({
        path: "/detailedorder",
        query: { orderID: ID, air_name: air_name },
      });
    },
    // 查询单个订单
    async searchOrder() {
      const { data } = await this.$post("OrderRecordPage", {
        ...this.params,
        OrderCode: this.search,
      });
      if (data.State) {
        this.allorder = JSON.parse(data.ReturnJson);
      }
    },
    changeSech() {
      if (this.search == "") {
        this.OrderRecordPage();
      }
    },
    toLink() {
      // https://shop375613435.taobao.com/   https://www.paibaoex.com/
      window.open(this.taoBaoUrl);
    },
    copy() {
      this.$Message.success("復制成功！");
    },
    selDate(key) {
      var today = new Date();
      var oneday = 1000 * 60 * 60 * 24;
      var st = " 00:00:00.000";
      var Ed = " 23:59:59.000";
      if (key == 0) {
        this.params.EndTime = "";
        this.params.StartTime = "";
      }
      if (key == 1) {
        //    今天
        this.params.StartTime = this.dateFmt(today) + st;
        this.params.EndTime = this.dateFmt(today) + Ed;
      }
      if (key == 2) {
        //    昨天
        this.params.StartTime = this.dateFmt(today - oneday) + st;
        this.params.EndTime = this.dateFmt(today) + Ed;
      }
      if (key == 3) {
        //    一周
        this.params.StartTime = this.dateFmt(today - oneday * 7) + st;
        this.params.EndTime = this.dateFmt(today) + Ed;
      }
      if (key == 4) {
        //    一月
        this.params.StartTime = this.dateFmt(today - oneday * 30) + st;
        this.params.EndTime = this.dateFmt(today) + Ed;
      }

      // console.log(this.params.StartTime);
      //      this.params.offset = 1;
      this.OrderRecordPage();
    },
    dateFmt(value) {
      if (null != value && "" != value) {
        var date = new Date(value);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        if (m < 10) {
          m = "0" + m;
        }
        var d = date.getDate();
        if (d < 10) {
          d = "0" + d;
        }
        return y + "-" + m + "-" + d;
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
// /deep/ .modal-content{
//   width: 500px ;
// }

/deep/.modal-content .PayButton {
  width: 50px !important;
  height: 60px !important;
  @include backgroundColor($_color);
}
/deep/.modal-bag .center {
  width: 500px;
}
/deep/.modal-bag .shuju {
  text-align: center;
  width: 500px;
}
/deep/.modal-bag .Tr td {
  // display: flex;
  // justify-content: center;
  margin: 20px 0;
  font-size: 14px;
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  .wuliu {
    width: 600px;
    height: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .img {
    width: 200px;
    height: 200px;
  }
}

.taobao {
  .linktaobao {
    color: #f00;
    text-decoration: underline;
    text-align: center;
    margin-top: 30px;
    cursor: pointer;
  }
  div {
    line-height: 40px;
    font-size: 28px;
  }
  p {
    line-height: 40px;
    font-size: 28px;
  }
}
.payBox {
  width: 600px;
  font-size: 16px;
  color: #333;
  .wuliu {
    width: 600px;
    height: 600px;
  }
  .pay-list {
    align-items: center;
    display: flex;
    flex-direction: row;
    margin-top: 20px;
    .pay-icon-list {
      margin-left: 20px;
    }
    span {
      font-size: 16px;
      color: #343434;
      font-weight: 400;
      line-height: 37px;
    }

    .icon-img {
      width: 60px;
      height: 60px;
      vertical-align: middle;
    }
  }
  .pay-top {
    margin-top: 20px;
  }
}

.contions {
  width: 1069px;
  background: #ffffff;
  padding: 20px 29px;
  .addOneCx {
    margin: 0 0 0 30px;
    position: absolute;
    left: 888px;
    cursor: pointer;
  }

  .addOneCx2 {
    left: 820px;
  }

  .addOneCx:hover {
    color: #e95098;
  }
  .tip02 {
    font-size: 16px;
    margin: 6px 0 0 0;
  }
  .Accumulatedamount {
    display: flex;
    justify-content: center;
    text-align: center;
    > div p:nth-child(1) {
      font-size: 14px;
      color: #666;
    }
    > div p:nth-child(2) {
      font-size: 24px;
      color: #000;
    }
    .img {
      vertical-align: middle;
      width: 15px;
      height: 15px;
      margin: -4px 0 0 6px;
    }
  }
  /deep/ .Allorders {
    // display: flex;
    // flex-direction: row;

    .tans {
      .shuju {
        position: absolute;
        left: 50%;
        top: 50%;
        font-size: 18px;
      }
      .ivu-tabs-bar {
        border-bottom: 0px solid #fff !important;
      }
      .ivu-tabs-nav .ivu-tabs-tab-active {
        @include color($_color);
      }
      // .ivu-tabs-nav .ivu-tabs-tab{
      //   margin-right: 0px;
      // }
    }
    .game {
      position: relative;
      display: flex;
      flex-direction: row;
      display: inline-block;
      top: -13px;
      left: 244px;
      height: 20px;
      .background {
        width: 63px;
        height: 31px;
        background: #ff6666;
        position: absolute;
        border-bottom-right-radius: 5px;
        border-top-right-radius: 5px;
        left: 237px;
        top: 1px;
        img {
          margin: 5px 19px;
          cursor: pointer;
        }
      }
      .ivu-select-single .ivu-select-selection {
        border: 0px solid #fff;
      }
    }
    .order {
      color: #666666ff;
      position: relative;
      background: #f1f5feff;
      width: 1029px;
      height: 30px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      line-height: 32px;
      font-size: 12px;
      font-weight: 400;
      .selelct {
        margin-left: 11px;
        .ivu-select-single .ivu-select-selection {
          border: 0px solid #ffffff85;
          background: #f1f5feff;
          height: 28px;
          margin: -5px 0 0 0px;
          color: #000;
        }
        .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
          color: #666666ff;
        }
      }
      .select1 {
        position: relative;
        left: 50px;
        .ivu-select-single .ivu-select-selection {
          border: 0px solid #ffffff85;
          background: #f1f5feff;
          height: 28px;
          margin: -5px 0 0 0px;
          color: #000;
        }
        .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
          color: #666666ff;
        }
      }
    }
  }
  .ordernumber:nth-child(1) {
    .square {
      // .two>div:nth-child(3){
      //   display: none;
      //   position: ;
      // }
    }
  }
  .ordernumber {
    margin: 20px 0 0 0;
    width: 1029px;
    height: 150px;
    background: #fcfcfcff;
    border: 1px #cccccc solid;
    .f1 {
      width: 1027px;
      height: 40px;
      background: #f1f1f1ff;
      display: flex;
      flex-direction: row;
      line-height: 40px;
      padding: 0 20px;
      position: relative;
      span {
        font-size: 12px;
        font-weight: 400;
      }
      span:nth-child(1) {
        color: #999999ff;
      }
      span:nth-child(2) {
        color: #666666ff;
      }
    }
    .square {
      display: flex;
      flex-direction: row;
      .one {
        padding: 20px 28px;
        display: flex;
        flex-direction: row;
        width: 500px;
        border-right: 1px solid #c2c2c2;
        height: 108px;
        .squareQ {
          width: 70px;
          height: 70px;
          .Block_qs {
            width: 75px;
            height: 50px;
            // background: #e95098;
            // color: #fff;
            cursor: pointer;
            // border: 1px solid #e95098;
            border-radius: 5px;
            position: relative;
            top: -121px;
            left: 769px;
          }
          .Block_qs:hover {
            color: #e95098;
          }
        }
        .one_square {
          margin: -8px 0 0 60px;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 221px;
          height: 100px;
          font-size: 12px;
          p {
            color: #666666ff;
          }
          span {
            color: #999999ff;
          }
        }
      }
      .two {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 500px;
        height: 108px;
        padding: 50px 0;
        div:nth-child(2) {
          color: red;
        }
        div {
          color: #999999ff;
          font-size: 12px;
          cursor: pointer;
          z-index: 5;
          width: 100px;
          padding: 0 0 0 25px;
        }
      }
    }
  }
}

.goods {
  padding: 0 30px;
  height: 30px;
  border-radius: 5px;
  text-align: center;
  @include backgroundColor($_color);
  display: inline-block;
  color: #fff;
  font-size: 16px;
  line-height: 32px;
  cursor: pointer;
}

.goods2 {
  padding: 8px 50px;
  margin-top: 10px;
  height: 46px;
  float: right;
}

#Tbaleone {
  margin: 10px 0;
}

.addMask /deep/ .modal-content{
  width: 800px;
  height: 90vh;
}

.addMask2 /deep/ .modal-content{
  width: 670px;
}
</style>



// WEBPACK FOOTER //
// src/pages/view/homeManage/myOrder.vue